// extracted by mini-css-extract-plugin
module.exports = {"container":"az_Cdb","description":"az_Ddb","prosAndConsTitle":"az_Edb","productsContainer":"az_Fdb","name":"az_Gdb","product":"az_Hdb","button":"az_Idb","buttonText":"az_Jdb"};